import { useState, useEffect, useRef } from "react";
import { AddLayout } from "../../../layouts";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  DatePicker,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  CardContent,
  Tab,
  Tabs,
  TabPanel,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
} from "../../../components";
import {
  AtivoServicoService,
  CondicoesPagamentoService,
  history,
  ImpressoraService,
  MeioPagamentoService,
  notification,
  OrcamentoServicosService,
  OrcamentoServicosItensService,
  OrcamentoServicosServicosService,
  PessoaService,
  ProdutosService,
  SessionService,
  TabelaVendaService,
  UsuarioService,
  EnderecosEstoqueService,
} from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros, formatDate, userLogs } from "../../../utils";
import { OrcamentoServico, OrcamentoServicoPrintEntity } from "./entities";
import { isAtivoVeiculo } from "../../ordem-servicos/add-ordem-servico/entities/campos-veiculo";
import { orcamentoServicoValidator } from "./middlewares";
import { useImportContext } from "../../../contexts/import.context";
import {
  AtivosOrcamentoServico,
  HistorioClienteDialog,
  HistoricoAtivosDialog,
  OrcamentoServicoListaPagamentos,
  OrcamentoServicoListaProdutos,
  OrcamentoServicoListaServicos,
  ResumoTotal,
} from "./components";
import EnvioWhatsappDialog from "./components/dialogComponents/EnvioWhatsappDialog";
import {
  calcularValorTotal,
  compararPagamentosTotalOrcamentoServico,
} from "./add-orcamento-servico";

const orcamentoServicoService = new OrcamentoServicosService();
const pessoaService = new PessoaService();
const ativoServicoService = new AtivoServicoService();
const sessionService = new SessionService();
const produtosService = new ProdutosService();
const usuariosService = new UsuarioService();
const orcamentoServicosItensService = new OrcamentoServicosItensService();
const orcamentoServicosServicosService = new OrcamentoServicosServicosService();
const meioPagamentoService = new MeioPagamentoService();
const condicoesPagamentoService = new CondicoesPagamentoService();
const tabelaVendaService = new TabelaVendaService();
const impressoraService = new ImpressoraService();
const enderecosEstoqueService = new EnderecosEstoqueService();

let orcamentoServicoEntity = { status: "ABERTO" };
let orcamentoServicoPrintEntity = {};

function tabProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddOrcamentoServico = ({ match }) => {
  const { id } = match.params;
  const [loading, setLoading] = useState(false);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [userLog, setUserLog] = useState({});
  const [orcamentoServico, setOrcamentoServico] = useState({
    ...orcamentoServicoEntity,
  });
  const [clienteList, setClienteList] = useState([]);
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [servicoList, setServicoList] = useState([]);
  const [prestadoresList, setPrestadoresList] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [usuariosList, setUsuariosList] = useState([]);
  const [produtoList, setProdutoList] = useState([]);
  const [listaOrcamentoServicoProdutos, setListaOrcamentoServicoProdutos] =
    useState([]);
  const [campoChave, setCampoChave] = useState(null);
  const [produto, setProduto] = useState(null);
  const [produtosSimilares, setProdutosSimilares] = useState([]);
  const [configuracoes, setConfiguracoes] = useState({});
  const [acrescimoPagamento, setAcrescimoPagamento] = useState(null);
  const [listaOrcamentoServicoPagamentos, setListaOrcamentoServicoPagamentos] =
    useState([]);
  const [listaOrcamentoServicoServicos, setListaOrcamentoServicoServicos] =
    useState([]);
  const [gerarPagamentos, setGerarPagamentos] = useState({});
  const [meioPagamentoSelecionado, setMeioPagamentoSelecionado] =
    useState(null);
  const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [meiosPagamentoCliente, setMeiosPagamentoCliente] = useState(null);
  const [condicaoPagParcelaList, setCondicaoPagParcelaList] = useState([]);
  const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  const [enderecosEstoqueList, setEnderecosEstoqueList] = useState([]);
  const [condicaoSelecionada, setCondicaoSelecionada] = useState(null);
  const [openHistoricoClienteDialog, setOpenHistoricoClienteDialog] =
    useState(false);
  const [openHistoricoAtivosDialog, setOpenHistoricoAtivosDialog] =
    useState(false);
  const [openDialogEnvioWhatsapp, setOpenDialogEnvioWhatsapp] = useState(false);

  const [idParaWhatsapp, setIdParaWhatsapp] = useState(id);

  const [orcamentosServicos, setOrcamentosServicos] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loadingHistorico, setLoadingHistorico] = useState(false);
  const [tabelas, setTabelas] = useState({
    cliente: null,
    grupoPessoa: null,
    todosProdutos: null,
  });
  const [abaValue, setAbaValue] = useState(0);
  const [inputClienteValue, setInputClienteValue] = useState("");

  const { initialCollapses } = useImportContext();
  const inputCliente = useRef();

  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("orcamento-servicos-visualizar");
  const permissaoAlterarVendedor = permissoesHelper.temPermisao(
    "alterar-vendedor-por-item",
  );
  const permissaoAlterarValorProduto = permissoesHelper.temPermisao(
    "alterar-valor-produto-orcamento-servicos",
  );
  const permissaoAlterarValorServico = permissoesHelper.temPermisao(
    "alterar-valor-servico-orcamento-servicos",
  );

  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const dadosEmpresa = sessionService.getEmpresaAndUsuario();
  const dadosEmpresaRelatorio = sessionService.getEmpresaRelatorio();

  useEffect(() => {
    buscarDadosIniciais();
  }, [id]);

  const buscarDadosIniciais = async () => {
    await buscarMeiosPagamento();
    await buscarPrestadoresServico();
    if (!id) {
      orcamentoServicoEntity = new OrcamentoServico({
        dataAbertura: formatDate.toSend(new Date()),
        status: "ABERTO",
      });
      setOrcamentoServico({ ...orcamentoServicoEntity });
      buscarAtivos();
    } else {
      await buscarOrcamentoServico();
    }
    await buscarUsuarios();
    buscarCondicoesPagamento();
    buscarConfiguracao();
    buscarVendedores();
    buscarEnderecosEstoque();
  };

  const buscarConfiguracao = () => {
    if (dadosEmpresa.empresa?.configuracoes) {
      const data = dadosEmpresa.empresa.configuracoes;
      orcamentoServicoEntity.setConfiguracoes(data);
      setOrcamentoServico({ ...orcamentoServicoEntity });
      setConfiguracoes(data);
    }
  };

  const atualizarEntidadePrint = () => {
    orcamentoServicoPrintEntity = new OrcamentoServicoPrintEntity(
      dadosEmpresaRelatorio,
      clienteSelecionado,
      orcamentoServicoEntity.itens || [],
      orcamentoServicoEntity.servicos || [],
      orcamentoServicoEntity.pagamentos || [],
      meioPagamentoList,
      prestadoresList,
      configuracoes?.modeloImpressaoPadraoOrcamentosServicos,
    );
  };

  const buscarOrcamentoServico = async () => {
    setLoading(true);
    const response = await orcamentoServicoService.getById(id);
    if (!response.isAxiosError) {
      const data = response.data;
      const ativosSalvos = data.ativos || [];
      orcamentoServicoEntity = new OrcamentoServico(data, id);
      orcamentoServicoEntity.initTotalPagamentos(data?.pagamentos || []);
      setOrcamentoServico({
        ...orcamentoServicoEntity,
        statusInicial: data.status,
      });
      setListaOrcamentoServicoPagamentos(data?.pagamentos || []);
      await buscarDadosClientes(data?.clienteId);
      await buscarAtivosParaEdicao(ativosSalvos);
      if (data?.itens?.length > 0) {
        await buscarProdutosAvancado(data?.itens || []);
      }
      if (data?.servicos?.length > 0) {
        const itens = data?.servicos.map((item) => ({
          ...item,
          totalItem: item.quantidade * item.valor - (item.desconto || 0),
        }));
        setListaOrcamentoServicoServicos(itens);
      }
    } else {
      responseErros(response);
    }
    setLoading(false);
  };

  const filtrarAtivoVeiculo = (lista) => {
    const veiculo = lista.find(isAtivoVeiculo);
    return veiculo ? [veiculo] : lista;
  };

  const buscarAtivos = async () => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = filtrarAtivoVeiculo(
        result.data.filter((ativo) => !!ativo?.ativado),
      );
      buscarCampoChave(listaDeAtivos);
      orcamentoServicoEntity.setAtivos(listaDeAtivos);
      setOrcamentoServico({ ...orcamentoServicoEntity });
    } else {
      responseErros(result);
    }
  };

  const buscarProdutosAvancado = async (itens) => {
    const produtosIds = itens.map(({ produtoId }) => produtoId);
    const filtro = {
      id: produtosIds,
      ativado: true,
      nonPaginated: true,
    };
    produtosService.getAllFiltroAvancado(filtro).then((result) => {
      if (!result.isAxiosError) {
        setProdutoList(result.data);
        if (itens && itens?.length) {
          preencherItens(itens, result.data);
        }
      } else {
        responseErros(result);
      }
    });
  };

  const buscarEnderecosEstoque = () => {
    const filter = {
      nonPaginated: true,
    };
    enderecosEstoqueService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setEnderecosEstoqueList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const preencherItens = (itensBusca, produtos) => {
    const itens = itensBusca.map((item) => {
      const produtoBusca = produtos.find(
        (produto) => produto.id == item.produtoId,
      );
      return {
        ...item,
        descricao: produtoBusca?.descricao,
        totalItem: calcularValorTotal(item),
      };
    });
    orcamentoServicoEntity.setChangeItens(itens);
    setOrcamentoServico({
      ...orcamentoServicoEntity,
    });
    setListaOrcamentoServicoProdutos(itens);
  };

  const buscarCampoChave = (listaDeAtivos) => {
    for (const ativo of listaDeAtivos) {
      if (ativo?.camposPersonalizados?.length) {
        const chave = ativo.camposPersonalizados.find(
          (campo) => campo.campoChave,
        );
        setCampoChave(chave);
        break;
      }
    }
  };

  const buscarAtivosParaEdicao = async (ativosSalvos) => {
    const result = await ativoServicoService.getAll();
    if (!result.isAxiosError) {
      const listaDeAtivos = result.data.filter((ativo) => !!ativo?.ativado);
      orcamentoServicoEntity.setAtivosComValoresSalvos(
        listaDeAtivos,
        ativosSalvos,
      );
      setOrcamentoServico((prevState) => ({
        ...orcamentoServicoEntity,
        statusInicial: prevState.statusInicial,
      }));
    } else {
      responseErros(result);
    }
  };

  const buscarPrestadoresServico = async () => {
    const filtro = {
      nonPaginated: true,
      tiposPessoaId: 5,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setPrestadoresList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarVendedores = () => {
    const config = dadosEmpresa.empresa.configuracoes;
    if (id || config?.vendedorPorItemServico) {
      const filtro = {
        nonPaginated: true,
        tiposPessoaId: 4,
        vendedor: true,
        ativado: true,
      };
      pessoaService.getAll(filtro).then((result) => {
        if (!result.isAxiosError) {
          setVendedoresList(result.data);
        } else {
          responseErros(result);
        }
      });
    } else {
      const usuario = {
        id: null,
        nomeRazaoSocial: dadosEmpresa.usuario.nome,
      };
      setVendedoresList([usuario]);
    }
  };

  const buscarUsuarios = async () => {
    const result = await usuariosService.getAllFiltroAvancado({
      nonPaginated: true,
    });
    if (!result.isAxiosError) {
      setUsuariosList(result.data.rows);
    } else {
      responseErros(result);
    }
  };

  const removerServicoCadastrado = async (idServico) => {
    setLoading(true);
    const res = await orcamentoServicosServicosService.deletarEmLote(idServico);
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const removerProdutoCadastrado = async (idProduto) => {
    setLoading(true);
    const res = await orcamentoServicosItensService.deletarEmLote(idProduto);
    if (!res.isAxiosError) {
      notification.deletadoSucesso();
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const buscarMeiosPagamento = async (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      nonPaginated: true,
    };
    meioPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setMeioPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarCondicoesPagamento = () => {
    const filtro = {
      nonPaginated: true,
      ativado: true,
    };
    condicoesPagamentoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setCondicaoPagamentoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarDocumentosCliente = async (clienteId) => {
    setLoadingHistorico(true);
    orcamentoServicoService
      .getAll({ clienteId })
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data.rows?.length) {
            setOrcamentosServicos(result.data.rows);
            setTotalItems(result.data.count);
          } else {
            setOrcamentosServicos([]);
            setTotalItems(0);
          }
        } else {
          responseErros(result);
        }
      })
      .finally(() => setLoadingHistorico(false));
  };

  async function onClickLog() {
    if ("userCreatedLog" in userLog) return;
    const logs = await userLogs(orcamentoServicoEntity);
    setUserLog(logs);
  }

  const handleDateChange = (fieldName, date) => {
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (!date || !isValidDate(date) || date.getFullYear() < 2000) {
      date = "Invalid Date";
    }
    orcamentoServicoEntity.setHandleChangeDate(fieldName, date);
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
  };

  async function validarOrcamentoServico(indiceSelecionado) {
    const pagamentosTotalOrcamentoServico =
      compararPagamentosTotalOrcamentoServico(orcamentoServicoEntity);
    if (pagamentosTotalOrcamentoServico) {
      setLoading(false);
      navegarAtePagamentos();
      return notification.alertaGenericos(
        "É necessário atualizar valor da(s) parcela(s)",
      );
    }
    await handleSubmit(indiceSelecionado);
  }

  const handleSubmit = async (indiceSelecionado) => {
    setLoading(true);
    orcamentoServicoValidator
      .validate(orcamentoServicoEntity, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await orcamentoServicoService.atualizar(
            id,
            orcamentoServicoEntity,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            initialCollapses();
            handleCancelar();
            history.push("/faturamento/orcamento-servicos");
          } else {
            buscarOrcamentoServico();
            responseErros(response);
          }
        } else {
          const response = await orcamentoServicoService.cadastrar(
            orcamentoServicoEntity,
          );
          setLoading(false);
          if (!response.isAxiosError) {
            setOrcamentoServico({ ...orcamentoServico, ...response.data });
            notification.cadastroSucesso();
            if (indiceSelecionado === 0) {
              const permissaoDeny = permissoesHelper.temPermisao(
                "orcamentos-enviar-documento-apos-criacao",
              );
              const props = {
                title: "Documento cadastrado com sucesso",
                text: `#${response.data.numeroDocumento}`,
                icon: "success",
                confirmButtonText: "IMPRIMIR",
                cancelButtonText:
                  permissaoDeny && dadosEmpresa.empresa?.whatsappSimples
                    ? "<i class='ph-bold ph-x'></i>"
                    : "FECHAR",
                showCancelButton: true,
                dangerMode: true,
              };
              if (permissaoDeny && dadosEmpresa.empresa?.whatsappSimples) {
                props.denyButtonText = "WHATSAPP";
                props.showDenyButton = true;
              }
              const confirmacaoAlerta = await notification.confirmacaoGenericos(
                props,
              );
              if (confirmacaoAlerta.isConfirmed) {
                await buscarOS(response.data.id);
                initialCollapses();
                handleCancelar();
                history.push("/faturamento/orcamento-servicos");
              } else if (confirmacaoAlerta?.isDenied) {
                atualizarEntidadePrint();
                setIdParaWhatsapp(response.data.id);
                setOpenDialogEnvioWhatsapp(true);
              } else {
                initialCollapses();
                handleCancelar();
                history.push("/faturamento/orcamento-servicos");
              }
            } else {
              handleCancelar();
            }
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.message?.includes("pagamento")) {
          navegarAtePagamentos();
        }
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    orcamentoServicoEntity = new OrcamentoServico({
      dataAbertura: formatDate.toSend(new Date()),
    });
    setOrcamentoServico({ ...orcamentoServicoEntity });
  };

  const buscarClientes = async () => {
    const eventValue = inputClienteValue;
    if (!eventValue) return;
    setLoadingAutoComplete(true);
    const filtro = {
      nomeRazaoSocial: eventValue,
      apelidoFantasia: eventValue,
      tiposPessoaId: 1,
      nonPaginated: true,
      ativado: true,
    };
    const res = await pessoaService.getAll(filtro);
    setLoadingAutoComplete(false);
    if (!res.isAxiosError) {
      setClienteList(res.data);
    } else {
      responseErros(res);
    }
  };

  const buscarProdutosSimilares = async (produtoId) => {
    if (produtoId) {
      produtosService.getById(produtoId).then((result) => {
        if (!result.isAxiosError) {
          setProdutosSimilares(result.data.similares);
        } else {
          responseErros(result);
        }
      });
    }
  };

  const buscarTodasTabelasVenda = async (pessoaId, intGrupoPessoaId) => {
    setLoading(true);
    try {
      const filtros = {
        ativado: true,
        nonPaginated: true,
        restritiva: true,
        tabelaRegente: true,
      };
      const response = await tabelaVendaService.getAll(filtros);
      if (response.isAxiosError) {
        responseErros(response);
        return;
      }
      const tabelasProcessadas = response.data.reduce(
        (acc, tabela) => {
          const pessoa = tabela?.pessoaIds.find(
            (tabelaPessoa) => tabelaPessoa.intPessoaId == pessoaId,
          );
          if (pessoa) {
            acc.cliente = tabela;
          } else if (tabela.intGrupoPessoaId === intGrupoPessoaId) {
            acc.grupoPessoa = tabela;
          } else {
            acc.todosProdutos = tabela;
          }
          return acc;
        },
        { cliente: null, grupoPessoa: null, todosProdutos: null },
      );
      setTabelas(tabelasProcessadas);
    } catch (error) {
      console.error("Erro ao buscar tabelas:", error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeAutocompleteCliente = async (newValue) => {
    if (!newValue || (newValue && newValue.id !== clienteSelecionado?.id)) {
      setListaOrcamentoServicoPagamentos([]);
      orcamentoServicoEntity.setChangePagamentos([]);
      setGerarPagamentos((prevState) => ({
        ...prevState,
        valorTitulo: orcamentoServicoEntity?.totalOrcamentoServico,
      }));
    }
    orcamentoServicoEntity.setHandleChangeAutoComplete("clienteId", newValue);
    setOrcamentoServico(() => ({
      ...orcamentoServicoEntity,
    }));
    setClienteSelecionado(newValue);
    await buscarDadosClientes(newValue?.id);
    if (newValue?.clientes?.length) {
      buscarTodasTabelasVenda(
        newValue?.id,
        newValue?.clientes?.[0]?.grupoPessoaId,
      );
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  const handleChangeInput = (event) => {
    orcamentoServicoEntity.setHandleChangeInput(
      event.target.name,
      event.target.value,
    );
    setOrcamentoServico(() => ({ ...orcamentoServicoEntity }));
  };

  const buscarDadosClientes = async (clienteId) => {
    if (!clienteId) return;
    pessoaService.getById(clienteId).then((result) => {
      if (!result.isAxiosError) {
        setClienteSelecionado(result.data);
        buscarDocumentosCliente(clienteId);
        filterMeiosPagamentoCliente(result.data.clientes[0]);
      } else {
        responseErros(result);
      }
    });
  };

  const filterMeiosPagamentoCliente = (cliente) => {
    const list = meioPagamentoList?.length ? meioPagamentoList : [];
    if (cliente?.meiosPagamento?.length) {
      const meioPagamentoIds = cliente.meiosPagamento.map(
        ({ meioPagamentoId }) => meioPagamentoId,
      );
      const filterMeioPagamento = list?.filter((item) =>
        meioPagamentoIds.includes(item.id),
      );
      setMeiosPagamentoCliente(filterMeioPagamento);
      const meioPagamentoValido = meioPagamentoIds.find(
        (id) => id === gerarPagamentos?.meioPagamentoId,
      );
      if (gerarPagamentos?.meioPagamentoId && !meioPagamentoValido) {
        setGerarPagamentos((prevState) => ({
          ...prevState,
          meioPagamentoId: null,
          condicaoPagamentoId: null,
        }));
        setCondicaoPagParcelaList([]);
      }
    } else {
      setMeiosPagamentoCliente(null);
    }
  };

  async function buscarOS(idParam) {
    setLoading(true);
    const idDoc = idParam || id;
    if (!idDoc) {
      setLoading(false);
      return notification.alertaGenericos(
        "Orçamento de serviço não cadastrado",
      );
    }
    atualizarEntidadePrint();
    const result = await orcamentoServicoService.getOS(
      idDoc,
      orcamentoServicoPrintEntity,
    );
    setLoading(false);
    if (!result.isAxiosError) {
      if (configuracoes?.impressaoDiretaOrcamentosServicos) {
        await print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  const navegarAtePagamentos = () => {
    setAbaValue(2);
    setTimeout(() => {
      const ref = document?.getElementById("pagamentos-os");
      ref?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const cancelarOrcamentoServico = async () => {
    const retornoAlerta = await notification.confirmacao(
      "Cancelar!",
      "Tem certeza que deseja cancelar esse orçamento de serviço?",
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await orcamentoServicoService.cancelar(id);
      if (!result.isAxiosError) {
        notification.alteracaoSucesso();
        buscarDadosIniciais();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const verificarStatus = (status) => {
    switch (status) {
      case "ABERTO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#4FBB53" }}></i>
        );
      case "IMPORTADO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#004780" }}></i>
        );
      case "CANCELADO":
        return (
          <i className="ph-fill ph-circle" style={{ color: "#DC3545" }}></i>
        );
      default:
        return null;
    }
  };

  const isImportado =
    id &&
    (orcamentoServico?.statusInicial === "IMPORTADO" ||
      orcamentoServico?.status === "IMPORTADO");
  const isCancelado =
    id &&
    (orcamentoServico?.statusInicial === "CANCELADO" ||
      orcamentoServico?.status === "CANCELADO");

  return (
    <AddLayout
      id={id}
      title={
        id ? "Editar Orçamento de Serviço" : "Cadastrar Orçamento de Serviço"
      }
      showUpdate={permissoesHelper.temPermisao("orcamento-servicos-editar")}
      onClickSalvar={validarOrcamentoServico}
      loading={loading}
      codigo={id ? `Nº Documento ${orcamentoServico?.numeroDocumento}` : null}
      userLog={id ? userLog : null}
      onClickLog={onClickLog}
      actions={
        id ? (
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {permissoesHelper.temPermisao("orcamento-servicos-cancelar") &&
              !isCancelado && (
                <Tooltip title="Cancelar Orçamento" arrow placement="bottom">
                  <span>
                    <IconButton
                      onClick={cancelarOrcamentoServico}
                      disabled={orcamentoServico?.status !== "ABERTO"}
                    >
                      <i
                        className="ph-fill ph-prohibit"
                        style={{ fontSize: 18 }}
                      ></i>
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            <Tooltip title="Imprimir Orçamento" arrow placement="left">
              <IconButton onClick={async () => await buscarOS()}>
                <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
              </IconButton>
            </Tooltip>
            <Tooltip title="Enviar por WhatsApp" arrow placement="bottom">
              <IconButton
                onClick={() => {
                  atualizarEntidadePrint();
                  setIdParaWhatsapp(id);
                  setOpenDialogEnvioWhatsapp(true);
                }}
              >
                <i
                  className="ph-fill ph-whatsapp-logo"
                  style={{ fontSize: 18, color: "#48A34C" }}
                ></i>
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <></>
        )
      }
      actionsTotalizadores={
        <ResumoTotal
          orcamentoServico={orcamentoServico}
          setOrcamentoServico={setOrcamentoServico}
          orcamentoServicoEntity={orcamentoServicoEntity}
          abaValue={abaValue}
          listaServicos={listaOrcamentoServicoServicos}
          setListaServicos={setListaOrcamentoServicoServicos}
          listaProdutos={listaOrcamentoServicoProdutos}
          setListaProdutos={setListaOrcamentoServicoProdutos}
        />
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            id="numeroDocumento"
            name="numeroDocumento"
            type="number"
            label="Nº Documento"
            variant="outlined"
            margin="normal"
            disabled
            value={orcamentoServico?.numeroDocumento ?? ""}
            InputProps={{ inputProps: { min: 0 } }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DatePicker
            id="dataVencimento"
            name="dataVencimento"
            label="Data de Vencimento"
            format="dd/MM/yyyy"
            disabled
            margin
            variant="filled"
            value={
              orcamentoServico?.dataVencimento
                ? orcamentoServico.dataVencimento
                : null
            }
            onChange={(date) => {
              setInputErro([]);
              handleDateChange("dataVencimento", date);
            }}
            error={inputErros.get("dataVencimento")}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            id="status"
            name="status"
            label="Status"
            variant="outlined"
            disabled
            margin="normal"
            value={orcamentoServico?.status ?? ""}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {verificarStatus(orcamentoServico?.status)}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Autocomplete
                id="clienteId"
                name="clienteId"
                options={clienteList}
                autoHighlight
                getOptionLabel={(option) => {
                  const codigoPessoa = option?.codigo
                    ? `${option.codigo} - `
                    : "";
                  return option ? codigoPessoa + option.nomeRazaoSocial : "";
                }}
                loading={loadingAutoComplete}
                loadingText="Carregando"
                noOptionsText={
                  inputClienteValue?.length
                    ? "Nenhum cliente encontrado"
                    : "Digite e pressione Buscar"
                }
                disabled={isImportado || isCancelado}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    error={inputErros.get("clienteId")}
                    required
                    disabled={isImportado || isCancelado}
                    variant="outlined"
                    onChange={(e) => setInputClienteValue(e.target.value)}
                    inputRef={inputCliente}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loadingAutoComplete ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                onChange={(_, newValue) =>
                  onChangeAutocompleteCliente(newValue)
                }
                value={clienteSelecionado}
                sx={{ flex: 1 }}
              />
              <Tooltip title="Buscar Cliente" arrow placement="bottom">
                <Button
                  variant="contained"
                  disabled={isImportado || isCancelado}
                  size="small"
                  sx={{
                    height: "56px",
                    borderRadius: "8px",
                    minWidth: "56px",
                    boxShadow: "none",
                  }}
                  onClick={buscarClientes}
                >
                  <i
                    className="ph-bold ph-magnifying-glass"
                    style={{ color: "#fff", fontSize: 18 }}
                  />
                </Button>
              </Tooltip>
              {!id &&
              orcamentoServico?.clienteId &&
              orcamentosServicos?.length ? (
                loadingHistorico ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <>
                    <Tooltip
                      title="Visualizar Histórico Cliente"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        variant="contained"
                        disabled={!orcamentoServico?.clienteId}
                        size="small"
                        sx={{
                          height: "56px",
                          borderRadius: "8px",
                          minWidth: "56px",
                          boxShadow: "none",
                        }}
                        onClick={() => setOpenHistoricoClienteDialog(true)}
                      >
                        <i
                          className="ph-fill ph-shopping-cart"
                          style={{ fontSize: 18, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                    <Tooltip
                      title="Visualizar Histórico de Ativos"
                      arrow
                      placement="bottom"
                    >
                      <Button
                        variant="contained"
                        disabled={!orcamentoServico?.clienteId}
                        size="small"
                        sx={{
                          height: "56px",
                          borderRadius: "8px",
                          minWidth: "56px",
                          boxShadow: "none",
                        }}
                        onClick={() => setOpenHistoricoAtivosDialog(true)}
                      >
                        <i
                          className="ph-fill ph-toolbox"
                          style={{ fontSize: 18, color: "white" }}
                        ></i>
                      </Button>
                    </Tooltip>
                  </>
                )
              ) : null}
            </Box>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AtivosOrcamentoServico
            setOrcamentoServico={setOrcamentoServico}
            orcamentoServicoEntity={orcamentoServicoEntity}
            orcamentosServicos={orcamentosServicos}
            isFechado={isImportado || isCancelado}
            somenteLeitura={!!id}
          />
        </Grid>
        {configuracoes?.exibirDescricaoServico && (
          <Grid item xs={12}>
            <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
              Descrição do Serviço
            </Typography>
            <TextareaAutosize
              id="observacoes"
              name="observacoes"
              className="textRolagem bg-transparent"
              label="Observacao"
              maxLength={550}
              disabled={isImportado || isCancelado}
              value={orcamentoServico?.observacoes}
              onChange={handleChangeInput}
            />
          </Grid>
        )}
      </Grid>

      <hr className="mt-4 mb-2" />

      <Grid item xs={12}>
        <Paper>
          <Tabs
            value={abaValue}
            onChange={(e, newValue) => setAbaValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="SERVIÇOS" {...tabProps(0)} />
            <Tab label="PRODUTOS" {...tabProps(1)} />
            <Tab label="PAGAMENTOS" {...tabProps(2)} />
          </Tabs>
        </Paper>

        <CardContent>
          <TabPanel value={abaValue} index={0}>
            <OrcamentoServicoListaServicos
              id={id}
              isFechado={isImportado || isCancelado}
              orcamentoServico={orcamentoServico}
              setOrcamentoServico={setOrcamentoServico}
              orcamentoServicoEntity={orcamentoServicoEntity}
              servicoList={servicoList}
              setServicoList={setServicoList}
              prestadoresList={prestadoresList}
              removerServicoCadastrado={removerServicoCadastrado}
              listaOrcamentoServicoPagamentos={listaOrcamentoServicoPagamentos}
              setListaOrcamentoServicoPagamentos={
                setListaOrcamentoServicoPagamentos
              }
              listaOrcamentoServicoServicos={listaOrcamentoServicoServicos}
              setListaOrcamentoServicoServicos={
                setListaOrcamentoServicoServicos
              }
              permissaoAlterarValorServico={permissaoAlterarValorServico}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={1}>
            <OrcamentoServicoListaProdutos
              id={id}
              isFechado={isImportado || isCancelado}
              setOrcamentoServico={setOrcamentoServico}
              produtoList={produtoList}
              setProdutoList={setProdutoList}
              listaOrcamentoServicoProdutos={listaOrcamentoServicoProdutos}
              setListaOrcamentoServicoProdutos={
                setListaOrcamentoServicoProdutos
              }
              removerProdutoCadastrado={removerProdutoCadastrado}
              setLoading={setLoading}
              orcamentoServico={orcamentoServico}
              orcamentoServicoEntity={orcamentoServicoEntity}
              buscarProdutosSimilares={buscarProdutosSimilares}
              produtosSimilares={produtosSimilares}
              setProdutosSimilares={setProdutosSimilares}
              produto={produto}
              setProduto={setProduto}
              meioPagamentoSelecionado={meioPagamentoSelecionado}
              acrescimoPagamento={acrescimoPagamento}
              tabelas={tabelas}
              listaOrcamentoServicoPagamentos={listaOrcamentoServicoPagamentos}
              setListaOrcamentoServicoPagamentos={
                setListaOrcamentoServicoPagamentos
              }
              vendedoresList={vendedoresList}
              setVendedoresList={setVendedoresList}
              usuariosList={usuariosList}
              configuracoes={configuracoes}
              permissaoAlterarVendedor={permissaoAlterarVendedor}
              permissaoAlterarValorProduto={permissaoAlterarValorProduto}
              isProdutoEdit={isProdutoEdit}
              setIsProdutoEdit={setIsProdutoEdit}
              enderecosEstoqueList={enderecosEstoqueList}
            />
          </TabPanel>

          <TabPanel value={abaValue} index={2}>
            <div id="pagamentos-orc">
              <OrcamentoServicoListaPagamentos
                id={id}
                orcamentoServico={orcamentoServico}
                setOrcamentoServico={setOrcamentoServico}
                listaOrcamentoServicoPagamentos={
                  listaOrcamentoServicoPagamentos
                }
                setListaOrcamentoServicoPagamentos={
                  setListaOrcamentoServicoPagamentos
                }
                condicaoPagamentoList={condicaoPagamentoList}
                gerarPagamentos={gerarPagamentos}
                setGerarPagamentos={setGerarPagamentos}
                condicaoSelecionada={condicaoSelecionada}
                setCondicaoSelecionada={setCondicaoSelecionada}
                condicaoPagParcelaList={condicaoPagParcelaList}
                setCondicaoPagParcelaList={setCondicaoPagParcelaList}
                meioPagamentoList={meioPagamentoList}
                meiosPagamentoCliente={meiosPagamentoCliente}
                orcamentoServicoEntity={orcamentoServicoEntity}
                meioPagamentoSelecionado={meioPagamentoSelecionado}
                setMeioPagamentoSelecionado={setMeioPagamentoSelecionado}
                listaOrcamentoServicoProdutos={listaOrcamentoServicoProdutos}
                setListaOrcamentoServicoProdutos={
                  setListaOrcamentoServicoProdutos
                }
                setAcrescimoPagamento={setAcrescimoPagamento}
                produto={produto}
                setProduto={setProduto}
                isFechado={isImportado || isCancelado}
              />
            </div>
          </TabPanel>
        </CardContent>
      </Grid>

      <HistorioClienteDialog
        open={openHistoricoClienteDialog}
        setOpen={setOpenHistoricoClienteDialog}
        clienteId={orcamentoServico?.clienteId}
        orcamentosServicos={orcamentosServicos}
        setOrcamentosServicos={setOrcamentosServicos}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        prestadoresList={prestadoresList}
        orcamentoServicoEntity={orcamentoServicoEntity}
        setOrcamentoServico={setOrcamentoServico}
        campoChave={campoChave}
        setListaOrcamentoServicoProdutos={setListaOrcamentoServicoProdutos}
        setListaOrcamentoServicoServicos={setListaOrcamentoServicoServicos}
      />

      <HistoricoAtivosDialog
        open={openHistoricoAtivosDialog}
        setOpen={setOpenHistoricoAtivosDialog}
        cliente={clienteSelecionado}
        orcamentosServicos={orcamentosServicos}
        orcamentoServicoEntity={orcamentoServicoEntity}
        setOrcamentoServico={setOrcamentoServico}
      />

      <EnvioWhatsappDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        data={{
          id: idParaWhatsapp,
          cliente: clienteSelecionado,
          empresa: dadosEmpresa?.empresa,
          imagemLogo: dadosEmpresa?.empresa?.imagemLogo,
          dataVencimentoFormat: orcamentoServico?.dataVencimento,
          dto: orcamentoServicoPrintEntity,
        }}
        initialCollapses={initialCollapses}
      />
    </AddLayout>
  );
};

export default AddOrcamentoServico;
